export default {
  currentlyRaising: 'The external funding the project needs now.',
  currentlyRaisingSize: 'The amount of external funding the project needs now.',
  founded:
    'If you have already registered the company, provide the date of incorporation. <br/>If not, the date when you started working on the project.',
  ir: 'Intellectual Property',
  mrr: 'Monthly Recurring Revenue in €, eg. 100000',
  previousRaising: 'Previous external or internal financing of the project.',
  documents:
    'Upload your Pitch Deck and any other documents you would like to share with investors. The Pitch Deck is required.',
  documentsPitch: 'Upload pitch deck(s) - this is required by most investors',
  documentsOthersNoPitchYet:
    'In order to be able to upload other documents you must provide a pitch deck first.',
}
